// クラシック版の作る画面の TS の部品（2026-10-25〜、段階 C の2。tools/chibi-unify/CLASSIC-UI.md）。
// tools/chibi-unify/build-ui.mjs が common/js/charat/charat.classic.min.js にまとめる。クラシック版のページは charat.common.min.js（描く関数・同意の印・旧処理）と
// 中身（charat.core.min.js）のあと、ページの起動（chibi.init）より前に読む。部品は前のエンジンと同じ名前（chibi.*・charat.common.*）に置く（旧処理・ページ・additional.js・
// セーブスロットからは今までどおり名前で呼ばれる）。2026-10-26 の 7h で前のエンジン（chibi.js・charat.common.js）と画面ファイル（layout/*.js）は無くなり、定数と設定もここ（consts.ts）
import { chibi, common, install } from './engine.js';
import { installConsts } from './consts.js';
import * as storage from './storage.js';
import * as colors from './colors.js';
import * as gradbar from './gradbar.js';
import * as patterns from './patterns.js';
import * as parts from './parts.js';
import * as category from './category.js';
import * as buttons from './buttons.js';
import * as menu from './menu.js';
import { makeMenuButtons } from './menubuttons.js';
import { makeEditButtons } from './editbuttons.js';
import { makeSubButtons } from './subbuttons.js';
import { makeZoomButton } from './zoom.js';
import * as complete from './complete.js';
import * as commonops from './commonops.js';
import * as dialogs from './dialogs.js';
import * as load from './load.js';
import * as boot from './boot.js';
import * as gen1pattern from './gen1pattern.js';
import * as nametext from './nametext.js';
import { screen } from './colors.js';
import { S } from './sel.js';
import * as jq from './jq.js';

// 0. 定数と設定（前の chibi.js・charat.common.js。ほかの部品より先に。ページの chibiConfig を読む）と、完成画面の窓口 window.charatFinishHost
installConsts();

// d3 の代わりの道具（前任者の処理 charat.legacy.js・セーブスロット slots.js・完成画面の窓口（consts.ts）が charat.sel.select などで使う。2026-10-26 の 7g-1）
(window as unknown as { charat: { sel?: unknown } }).charat.sel = S;
// jQuery の代わりの道具（前任者の処理 charat.legacy.js が charat.jq.show・attr・on・delegate・ready などで使う。2026-10-26 の 7g-4）
(window as unknown as { charat: { jq?: unknown } }).charat.jq = jq;
// 動いている jQuery の代わりの動きの数（確かめる道具が「動きが終わるまで待つ」に使う。前は jQuery(':animated')。2026-10-26 の 7g-2）
(window as unknown as { charat: { fx?: unknown } }).charat.fx = { animating: jq.animatingCount };

// 1. 保存データとストレージ
install(common(), {
  getSaveText: storage.getSaveText,
  setStrage: storage.setStrage,
  getStrage: storage.getStrage,
  zipStrToStr: storage.zipStrToStr,
  strToZipStr: storage.strToZipStr,
  strToByteArray: storage.strToByteArray,
  byteArrayToStr: storage.byteArrayToStr,
  isUseLocalStorage: storage.isUseLocalStorage,
  isUseSessionStorage: storage.isUseSessionStorage,
  getSaveFileName: storage.getSaveFileName,
  fetchCategoryText: storage.fetchCategoryText,
  postJSON: storage.postJSON,
});
install(chibi(), {
  saveChara: storage.saveChara,
  loadChara: storage.loadChara,
  makeDB: storage.makeDB,
  saveDB: storage.saveDB,
  loadDB: storage.loadDB,
  loadUserID: storage.loadUserID,
  loadReload: storage.loadReload,
  isFirst: storage.isFirst,
  setFirst: storage.setFirst,
});

// 2a. 色の列と色の選択（mono の selColor は下の 7e が上書きで置く）
install(chibi(), {
  setColorList: colors.setColorList,
  selColor: colors.selColor,
  setGradFromTo: colors.setGradFromTo,
  selGrad: colors.selGrad,
  setAllGradColor: colors.setAllGradColor,
});

// 2b. グラデーションのバー
install(chibi(), { setGradBar: gradbar.setGradBar });

// 2c. 柄の一覧と柄の選択（mono の柄の一連の関数は下の 7e が上書きで置く）
install(chibi(), {
  setPatternList: patterns.setPatternList,
  selPattern: patterns.selPattern,
  clearPattern: patterns.clearPattern,
  setPattern: patterns.setPattern,
});

// 3. パーツの一覧（getPartsLayerList はエンジンの applyEnginePatterns・applySaveStroke からも呼ばれる）
install(chibi(), {
  setPartsList: parts.setPartsList,
  selPartsStyle: parts.selPartsStyle,
  getSelLayerId: parts.getSelLayerId,
  getPartsLayerList: parts.getPartsLayerList,
});

// 4. カテゴリのボタンと、キャラのデータを受け取ったあとの用意（起動の init が呼ぶ）
install(chibi(), { setCategory: category.setCategory });

// 5a. ボタンを並べる部品（charat.common に置く。セーブスロットの slots.js が、このあとで makeFloatButton を包む）
install(common(), { makeMenuButton: buttons.makeMenuButton, makeFloatButton: buttons.makeFloatButton });

// 5b. 右の列のボタンの並び
install(chibi(), { setNewMakeManu: menu.setNewMakeManu });

// 5c-1. メニューの一覧などの小さいボタンの定義（mono の色の入れかえ・第1世代の名前は下の 7e・7f が上書きで置く）
install(chibi(), makeMenuButtons());

// 5c-2. 編集のボタンの定義（mono の色は下の 7e が上書きで置く）
install(chibi(), makeEditButtons());

// 5c-3. 調整のボタンの定義（jakigan の反転は REVERSE_TOGGLE の版）
install(chibi(), makeSubButtons());

// 5d. 拡大して見るボタン（11 通りを設定 ZOOM_* に）
install(chibi(), { btnSubZoom: makeZoomButton() });

// 6. 完成画面（画像にする writeImageFromSVG は charat.common に）
install(chibi(), { makeComplete: complete.makeComplete, setMakeComplete: complete.setMakeComplete });
install(common(), { writeImageFromSVG: complete.writeImageFromSVG });

// 7a. charat.common の道具（SVG の文字から・パーツの差しかえの動き・色・柄・線・うすさ・回転・移動・拡大・反転・計算・メニューのボタンの動き・切り抜き・吹き出し・SVG の入れ物）
// mono の makePattern は下の 7e が上書きで置く
install(common(), {
    getAllGfromSVG: commonops.getAllGfromSVG,
    getGfromSVG: commonops.getGfromSVG,
    replaceGrad: commonops.replaceGrad,
    changeParts: commonops.changeParts,
    checkLayer: commonops.checkLayer,
    getLayer: commonops.getLayer,
    changeColor: commonops.changeColor,
    changeRevColor: commonops.changeRevColor,
    setGradColor: commonops.setGradColor,
    makePattern: commonops.makePattern,
    setStrokeWidth: commonops.setStrokeWidth,
    OpacityG: commonops.OpacityG,
    initOpacitySlider: commonops.initOpacitySlider,
    toggleOpacityDisplay: commonops.toggleOpacityDisplay,
    rotateCenter: commonops.rotateCenter,
    rotateAllLayers: commonops.rotateAllLayers,
    rotateSelectedLayers: commonops.rotateSelectedLayers,
    rotateSelectedLayersReverse: commonops.rotateSelectedLayersReverse,
    rotateByDelta: commonops.rotateByDelta,
    moveG: commonops.moveG,
    zoomG: commonops.zoomG,
    reverseG: commonops.reverseG,
    getReverseG: commonops.getReverseG,
    getXYfromIndex: commonops.getXYfromIndex,
    addRgb: commonops.addRgb,
    addColor: commonops.addColor,
    convToHexRgb: commonops.convToHexRgb,
    convToRgb: commonops.convToRgb,
    getScale: commonops.getScale,
    moveButton: commonops.moveButton,
    inverseColor: commonops.inverseColor,
    getPartsNoFromG: commonops.getPartsNoFromG,
    changeMask: commonops.changeMask,
    viewTooltip: commonops.viewTooltip,
    toggleReverseStatus: commonops.toggleReverseStatus,
    getD3SVG: commonops.getD3SVG,
    getD3SVGWidhG: commonops.getD3SVGWidhG,
});
// 7b. ダイアログと覆う画面
install(common(), {
  finishModal: dialogs.finishModal,
  setNowLoading: dialogs.setNowLoading,
  setNowMaking: dialogs.setNowMaking,
  setFirstCheck: dialogs.setFirstCheck,
  openDialog: dialogs.openDialog,
});
// 7c. キャラの読み込みと中身とのつなぎ（mono の setPartsColorPattern は下の 7e が上書きで置く。替えたかは setPartsColorPatternStd と比べる）
install(chibi(), {
    setPartsColorPattern: load.setPartsColorPattern,
    getValidStrokeWidth: load.getValidStrokeWidth,
    getGroupCategory: load.getGroupCategory,
    getExcludeCategory: load.getExcludeCategory,
    loadRandom: load.loadRandom,
    loadDefault: load.loadDefault,
    load: load.load,
    getChara: load.getChara,
    applyMask: load.applyMask,
    toStdSaveLine: load.toStdSaveLine,
    core: load.coreAttach,
    coreOps: load.coreOps,
    coreLayerTransform: load.coreLayerTransform,
    coreZoomTransform: load.coreZoomTransform,
    refreshLayers: load.refreshLayers,
    toStdSave: load.toStdSave,
    applyEnginePatterns: load.applyEnginePatterns,
    applySaveStroke: load.applySaveStroke,
    replayHandHook: load.replayHandHook,
    makeCharactorCore: load.makeCharactorCore,
    makeCharactor: load.makeCharactor,
    enterFullscreen: load.enterFullscreen,
    debug: load.debug,
    reverseAll: load.makeReverseAll(),
});
(chibi() as unknown as Record<string, unknown>).setPartsColorPatternStd = load.setPartsColorPattern;

// 7d. 起動（init・カテゴリを読んだあとの initMode・はじめの確認・作り始めの仕上げ）
install(chibi(), { init: boot.init, initMode: boot.initMode, checkFirst: boot.checkFirst, firstMessage: boot.firstMessage });

// ---- メーカー・系統だけの部品（ほかの部品を置いたあとに上書きで置く） ----
const cfg = <T>(key: string, def: T): T => (chibi() as unknown as { config<U>(k: string, d: U): U }).config(key, def);
const gen1 = screen() === 'gen1a' || screen() === 'gen1b';
// 7e. 第1世代の柄（mono。PATTERN_IN_COLOR）。setPartsColorPatternStd は上の一般の版のまま（替えたかを中身が見る）
if (cfg('PATTERN_IN_COLOR', false)) {
  install(chibi(), {
    selColor: gen1pattern.selColor,
    setPatternList: gen1pattern.setPatternList,
    selPattern: gen1pattern.selPattern,
    clearPattern: gen1pattern.clearPattern,
    setPattern: gen1pattern.setPattern,
    changePattern: gen1pattern.changePatternChibi,
    copyPattern: gen1pattern.copyPattern,
    setPartsColorPattern: gen1pattern.setPartsColorPattern,
    ...gen1pattern.makeGen1PatternButtons(),
  });
  install(common(), { changePattern: gen1pattern.changePattern, makePattern: gen1pattern.makePattern });
}
// 7f. 第1世代の名前の円弧（NAME_ARC）と名前のダイアログ（dressup の NAME_DIALOG_GEN2 は上の legacy の版）
if (gen1 && cfg('NAME_ARC', false)) install(chibi(), { setTextArea: nametext.setTextArea });
if (gen1 && !cfg('NAME_DIALOG_GEN2', false)) install(chibi(), { btnMenuName: nametext.makeGen1NameButton() });
// 7f. 似顔絵の旧処理（charat.legacy.js の <名前>Portrait を同じ名前に。前は画面ファイル portrait.js が上書きしていた）
if (cfg<string>('LEGACY', '') === 'portrait') {
  const c = common() as unknown as Record<string, unknown>;
  for (const name of ['adjustSVGColors', 'palletChange', 'applyClipping', 'skinColorLink', 'updateEyeshadowVisibility', 'updateHandVisibility', 'updateSexflgAttributes']) {
    c[name] = c[name + 'Portrait'];
  }
}
